import client from './client';
import mock from './mock';

const isProd = process.env.NODE_ENV === 'production';
const authClient = isProd ? client : window.Cypress ? mock : client;

export default authClient;
